import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PrimerSessionIntentPropsAndroid from '../../common/primerSessionIntentProps.mdx';
import PrimerPaymentMethodManagerCategoryPropsAndroid from './primerPaymentMethodManagerCategoryProps.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='paymentMethodType' subtitle='String' label='Required' mdxType="Item">
  A unique string identifier for the payment method.
    </Item>
    <Item title='supportedPrimerSessionIntents' subtitle='List<PrimerSessionIntent>' label='Required' mdxType="Item">
    A list of PrimerSessionIntent which defines what intents can be used with this payment method.
    <Group summary='PrimerSessionIntent' open={props.openGroup} mdxType="Group">
        <PrimerSessionIntentPropsAndroid mdxType="PrimerSessionIntentPropsAndroid" />
    </Group>
    </Item>
    <Item title='paymentMethodManagerCategories' subtitle='PrimerPaymentMethodManagerCategory' label='Required' mdxType="Item">
  A list which defines the payment method managers that can be used with this payment method.
	<Group summary='PrimerPaymentMethodManagerCategory' open={props.openGroup} mdxType="Group">
        <PrimerPaymentMethodManagerCategoryPropsAndroid mdxType="PrimerPaymentMethodManagerCategoryPropsAndroid" />
  </Group>
    </Item>
    <Item title='requiredInputDataClass' subtitle='KClass<out PrimerRawData>?' mdxType="Item">
      <p>{`Indicates the subclass of the PrimerRawData that must be set using the `}<a parentName="p" {...{
          "href": "./../../rawDataManagerSetRawData"
        }}>{`PrimerHeadlessUniversalCheckoutRawManager`}</a>{`.`}</p>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      